<div class="max-w-xs text-sm text-{{config.color}}-800 rounded-lg" (click)="snackBarRef.dismissWithAction()"
    role="alert">
    <div class="flex p-4 gap-3">
        <div>
            <mat-icon >{{ config.icon }}</mat-icon>
        </div>
        <span class="text-xl font-bold">
            {{ config.message }}
        </span>
    </div>
</div>
